import { render, staticRenderFns } from "./shifts.vue?vue&type=template&id=64c7f21a&"
import script from "./shifts.vue?vue&type=script&lang=js&"
export * from "./shifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports